import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=04d6f101&scoped=true&"
import script from "./svgIcon.vue?vue&type=script&lang=js&"
export * from "./svgIcon.vue?vue&type=script&lang=js&"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=04d6f101&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d6f101",
  null
  
)

component.options.__file = "svgIcon.vue"
export default component.exports